module.exports = __webpack_public_path__ + "media/images/icons/icon-offer-letter-971d6d3000504e9ddd02860b082c89af.svg";